





































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateBranchGeneralDetailsRequest from '@/models/Branches/UpdateBranchGeneralDetailsRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import BranchDto from '@/models/Branches/BranchDto';

@Component({
    name: 'BranchGeneralDetailsEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new BranchDto();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentBranch));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateBranchGeneralDetailsRequest()
    request.updatedAt = this.entity.updatedAt;
    request.registeredName = this.entity.registeredName;
    request.registrationNumber = this.entity.registrationNumber;
    request.taxNumber = this.entity.taxNumber;
    
    await AgencySettingsModule.editBranchGeneralDetails(request)
    this.dialog = false;
  }
}
